import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  autocomplete: {
    minWidth: 300,
    '& .MuiAutocomplete-inputRoot': {
      paddingRight: '14px !important',
    },
    '& .MuiAutocomplete-tag': {
      margin: '2px',
    },
    '& .MuiAutocomplete-input': {
      padding: '8.5px 4px 8.5px 6px',
    },
  },
}));
